(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7437],{

/***/ 14524:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/qna/realtime",
      function () {
        return __webpack_require__(86130);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var ArrowsButtonDownMin = function(param) {
    var _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray400 */ .Z.color.gray400 : _color, _size = param.size, size = _size === void 0 ? 16 : _size, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.3594 5.40002L8.03125 8.8219L4.70312 5.40002L3.75 6.3219L8.03125 10.7281L12.3125 6.3219L11.3594 5.40002Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonDownMin);


/***/ }),

/***/ 16718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ spinner; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/spinner/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dashoffset: -124px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  vertical-align: middle;\n  transform-origin: center;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: none;\n  stroke: ",
        ";\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: ",
        " calc(2s * 0.75) ease-in-out infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Stretch = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var SpinnerContainer = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-87510cb7-0"
})(_templateObject2(), function(param) {
    var _size = param.size, size = _size === void 0 ? 28 : _size;
    return {
        width: "".concat(size, "px"),
        height: "".concat(size, "px")
    };
}, Rotate);
var SpinnerCircle = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-87510cb7-1"
})(_templateObject3(), function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.white */.Z.color.white : _color;
    return color;
}, Stretch);

;// CONCATENATED MODULE: ./src/components/atom/spinner/index.tsx
/* Ref. https://github.com/GriffinJohnston/uiball-loaders/blob/main/src/components/Ring.js */ 

var Spinner = function(param) {
    var color = param.color, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerContainer, {
        viewBox: "25 25 50 50",
        strokeWidth: "5",
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerCircle, {
            cx: "50",
            cy: "50",
            r: "20",
            color: color
        })
    });
};
/* harmony default export */ var spinner = (Spinner);


/***/ }),

/***/ 29697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_PaginationComponent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/lucide-react/dist/esm/icons/ellipsis.js
var ellipsis = __webpack_require__(60301);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/class-variance-authority/dist/index.mjs
var dist = __webpack_require__(10929);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/dn-design-system/components/ui/pagination.tsx











var paginationVariants = (0,dist/* cva */.j)("typography-ui-17sb flex items-center justify-center", {
    variants: {
        variant: {
            disabled: "rounded-[50%] bg-white",
            default: "rounded-[50%] bg-white text-gray-500 hover:bg-gray-50",
            active: "rounded-[50%] bg-primary-600 text-white"
        },
        size: {
            default: "h-[32px] min-w-[32px] px-[2px]",
            icon: "h-[28px] min-w-[28px] px-[2px]"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
var Pagination = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("nav", (0,_object_spread/* default */.Z)({
        role: "navigation",
        "aria-label": "pagination",
        className: (0,style.cn)("mx-auto mt-[20px] flex w-full justify-center", className)
    }, props));
};
Pagination.displayName = "Pagination";
var PaginationContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("ul", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,style.cn)("flex flex-row items-center gap-[4px]", className)
    }, props));
});
PaginationContent.displayName = "PaginationContent";
var PaginationItem = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("li", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,style.cn)("", className)
    }, props));
});
PaginationItem.displayName = "PaginationItem";
var PaginationLink = function(_param) {
    var className = _param.className, isActive = _param.isActive, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _size = _param.size, size = _size === void 0 ? "default" : _size, href = _param.href, _scroll = _param.scroll, scroll = _scroll === void 0 ? true : _scroll, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "isActive",
        "variant",
        "size",
        "href",
        "scroll"
    ]);
    var disabled = variant === "disabled";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-current": isActive ? "page" : undefined,
        href: href,
        scroll: scroll
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-disabled": disabled,
            tabIndex: disabled ? -1 : undefined,
            className: (0,style.cn)(paginationVariants({
                variant: variant,
                size: size
            }), className, disabled ? "pointer-events-none" : ""),
            children: props.children
        })
    }));
};
PaginationLink.displayName = "PaginationLink";
var PaginationPrevious = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to previous page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_arrow_left",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationPrevious.displayName = "PaginationPrevious";
var PaginationDoublePrevious = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to double previous page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_double_arrow_left",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationDoublePrevious.displayName = "PaginationDoublePrevious";
var PaginationNext = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to next page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_arrow_right",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationNext.displayName = "PaginationNext";
var PaginationDoubleNext = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(PaginationLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "Go to double next page",
        size: "icon",
        variant: props.isActive ? "default" : "disabled",
        className: (0,style.cn)("", className)
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
            name: "keyboard_double_arrow_right",
            size: 28,
            color: props.isActive ? theme/* default.color.gray600 */.Z.color.gray600 : theme/* default.color.gray200 */.Z.color.gray200,
            filled: true
        })
    }));
};
PaginationDoubleNext.displayName = "PaginationDoubleNext";
var PaginationEllipsis = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsxs)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-hidden": true,
        className: (0,style.cn)("flex h-9 w-9 items-center justify-center", className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ellipsis/* default */.Z, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "More pages"
            })
        ]
    }));
};
PaginationEllipsis.displayName = "PaginationEllipsis";


;// CONCATENATED MODULE: ./src/hooks/common/usePagination.ts

var PaginationType;
(function(PaginationType) {
    PaginationType["DOUBLE_PREVIOUS"] = "DOUBLE_PREVIOUS";
    PaginationType["PREVIOUS"] = "PREVIOUS";
    PaginationType["NEXT"] = "NEXT";
    PaginationType["DOUBLE_NEXT"] = "DOUBLE_NEXT";
    PaginationType["LINK"] = "LINK";
})(PaginationType || (PaginationType = {}));
var getPageInfos = function(page, totalPage, perPage) {
    var pageInfo = [];
    var halfPerPage = Math.floor(perPage / 2);
    var startPage = page - halfPerPage;
    var endPage = page + halfPerPage;
    if (startPage < 1) {
        startPage = 1;
        endPage = Math.min(perPage, totalPage);
    } else if (endPage > totalPage) {
        endPage = totalPage;
        startPage = Math.max(1, totalPage - perPage + 1);
    }
    var doublePreviousPage = Math.max(1, page - perPage);
    pageInfo.push({
        type: PaginationType.DOUBLE_PREVIOUS,
        page: doublePreviousPage,
        isActive: page > 1
    });
    var previousPage = Math.max(1, page - 1);
    pageInfo.push({
        type: PaginationType.PREVIOUS,
        page: previousPage,
        isActive: page > 1
    });
    for(var i = startPage; i <= endPage; i++){
        pageInfo.push({
            type: PaginationType.LINK,
            page: i,
            isActive: i === page
        });
    }
    var nextPage = Math.min(totalPage, page + 1);
    pageInfo.push({
        type: PaginationType.NEXT,
        page: nextPage,
        isActive: page < totalPage
    });
    var doubleNextPage = Math.min(totalPage, page + perPage);
    pageInfo.push({
        type: PaginationType.DOUBLE_NEXT,
        page: doubleNextPage,
        isActive: page < totalPage
    });
    return pageInfo;
};
var usePagination = function(page, totalPage) {
    var perPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    var ref = (0,react.useState)(function() {
        return getPageInfos(page, totalPage, perPage);
    }), pageInfos = ref[0], setPageInfos = ref[1];
    (0,react.useEffect)(function() {
        setPageInfos(getPageInfos(page, totalPage, perPage));
    }, [
        page,
        totalPage,
        perPage
    ]);
    return pageInfos;
};
/* harmony default export */ var common_usePagination = (usePagination);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/hooks/useScrollRestoration.ts


var useScrollRestoration = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        ref: undefined,
        enabled: true
    }, ref1 = ref.ref, _enabled = ref.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var router = (0,next_router.useRouter)();
    var isPopStateRef = (0,react.useRef)(false);
    var pendingScrollRef = (0,react.useRef)(null);
    var scrollKey = function(path) {
        return "scrollPos_".concat(path);
    };
    var saveScrollPos = function(path) {
        var scrollPos = (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) ? {
            x: ref1.current.scrollLeft,
            y: ref1.current.scrollTop
        } : {
            x: window.scrollX,
            y: window.scrollY
        };
        sessionStorage.setItem(path, JSON.stringify(scrollPos));
    };
    var getSavedScrollPos = function(path) {
        var savedPos = sessionStorage.getItem(path);
        if (!savedPos) return null;
        return JSON.parse(savedPos);
    };
    var applyScrollPosition = function(x, y) {
        var targetElement = (ref1 === null || ref1 === void 0 ? void 0 : ref1.current) || window;
        requestAnimationFrame(function() {
            targetElement.scrollTo(x, y);
        });
    };
    (0,react.useLayoutEffect)(function() {
        if (enabled && pendingScrollRef.current) {
            var _current = pendingScrollRef.current, x = _current.x, y = _current.y;
            applyScrollPosition(x, y);
            pendingScrollRef.current = null;
        }
    });
    (0,react.useLayoutEffect)(function() {
        if (!enabled) return;
        if (!("scrollRestoration" in window.history)) return;
        window.history.scrollRestoration = "manual";
        var currentPath = scrollKey(router.asPath);
        var onRouteChangeStart = function() {
            if (!isPopStateRef.current) {
                saveScrollPos(currentPath);
            }
        };
        var onRouteChangeComplete = function() {
            var newPath = scrollKey(router.asPath);
            if (isPopStateRef.current) {
                var savedPos = getSavedScrollPos(newPath);
                if (savedPos) {
                    pendingScrollRef.current = savedPos;
                }
                isPopStateRef.current = false;
            } else {
                pendingScrollRef.current = {
                    x: 0,
                    y: 0
                };
            }
        };
        router.beforePopState(function() {
            isPopStateRef.current = true;
            return true;
        });
        router.events.on("routeChangeStart", onRouteChangeStart);
        router.events.on("routeChangeComplete", onRouteChangeComplete);
        return function() {
            router.events.off("routeChangeStart", onRouteChangeStart);
            router.events.off("routeChangeComplete", onRouteChangeComplete);
        };
    }, [
        ref1,
        router.asPath,
        enabled
    ]);
};

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/components/common/PaginationComponent.tsx








var PaginationComponent = function(props) {
    var queries = props.queries, baseUrl = props.baseUrl, _pageKeyName = props.pageKeyName, pageKeyName = _pageKeyName === void 0 ? "page" : _pageKeyName, _scroll = props.scroll, scroll = _scroll === void 0 ? true : _scroll, _scrollRestoration = props.scrollRestoration, scrollRestoration = _scrollRestoration === void 0 ? true : _scrollRestoration, _perPage = props.perPage, perPage = _perPage === void 0 ? 5 : _perPage, totalPage = props.totalPage, currentPage = props.currentPage;
    var pageInfos = common_usePagination(currentPage, totalPage, perPage);
    useScrollRestoration({
        ref: undefined,
        enabled: scrollRestoration
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationContent, {
            children: pageInfos.map(function(pageInfo) {
                switch(pageInfo.type){
                    case PaginationType.DOUBLE_PREVIOUS:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDoublePrevious, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.PREVIOUS:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationPrevious, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.LINK:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationLink, {
                                isActive: pageInfo.isActive,
                                variant: pageInfo.isActive ? "active" : "default",
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page))),
                                children: pageInfo.page
                            })
                        }, "pagination-".concat(pageInfo.type, "-").concat(pageInfo.page));
                    case PaginationType.NEXT:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationNext, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                    case PaginationType.DOUBLE_NEXT:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationDoubleNext, {
                                isActive: pageInfo.isActive,
                                scroll: scroll,
                                href: baseUrl + (0,url/* addQueryString */.sC)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), (0,_define_property/* default */.Z)({}, pageKeyName, pageInfo.page)))
                            })
                        }, "pagination-".concat(pageInfo.type));
                }
            })
        })
    });
};
/* harmony default export */ var common_PaginationComponent = (PaginationComponent);


/***/ }),

/***/ 8366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/spinner/index.tsx + 1 modules
var spinner = __webpack_require__(16718);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/molecules/loader/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59f274fe-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/molecules/loader/index.tsx



var Loader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
            size: props.size,
            color: props.color
        })
    });
};
/* harmony default export */ var loader = (Loader);


/***/ }),

/***/ 42411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70691);
/* harmony import */ var _constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99529);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95613);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44376);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);







var AppInstallTopBanner = function(param) {
    var onClickClose = param.onClickClose, content = param.content, trackingInfo = param.trackingInfo, onLogEvent = param.onLogEvent;
    var ref = trackingInfo !== null && trackingInfo !== void 0 ? trackingInfo : {}, contentCategory = ref.contentCategory, contentId = ref.contentId, contentTitle = ref.contentTitle, campaign = ref.campaign, contentSubCategory = ref.contentSubCategory;
    var airbridgeDynamicLink = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAirbridgeDynamicLink */ .e)();
    var onClickInstallApp = function() {
        onLogEvent === null || onLogEvent === void 0 ? void 0 : onLogEvent();
        airbridgeDynamicLink.navigateWithTracking(_constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_2__/* .DeeplinkLoggerEventName.ClickCtaButton */ .l.ClickCtaButton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            campaign: campaign,
            content: content,
            term: "바로 진료받기",
            sub_id: contentId,
            sub_id_1: contentTitle,
            sub_id_2: contentCategory
        }, contentSubCategory && {
            sub_id_3: contentSubCategory
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sticky top-[60px] z-[300] flex w-full items-center justify-between bg-gray-700 pt-[14px] pr-[20px] pb-[12px] pl-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onClickClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: _styles_theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.gray300 */ .Z.color.gray300,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-13m text-white",
                                children: "병원 문 닫은 늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-15sb text-white",
                                children: "닥터나우는 24시간 열려있어요!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "typography-ui-13m h-[32px] rounded-lg border bg-primary-600 px-[8px] text-white",
                    onClick: onClickInstallApp,
                    children: "바로 진료받기"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppInstallTopBanner);


/***/ }),

/***/ 33193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ai_notification_banner; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/atom/icon/Megaphone.tsx

var Megaphone = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1748_34679)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.31885 9.51785V12.785C2.31885 14.5312 3.73449 15.9469 5.48077 15.9469C7.22704 15.9469 8.64269 14.5312 8.64269 12.785C8.64269 12.2491 8.64269 11.7321 8.64269 11.7321L2.31885 9.51785Z",
                        fill: "#A5D8FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.9727 0.0651706C14.7951 0.0389713 14.614 0.0552535 14.4439 0.11268L1.19832 4.72082C0.866226 4.83691 0.578277 5.05306 0.374089 5.33953C0.169902 5.62601 0.059507 5.96872 0.0581055 6.32051V7.55941L0.058437 7.5788C0.0701694 7.92181 0.185336 8.25325 0.388819 8.52961C0.592303 8.80599 0.874657 9.0144 1.19871 9.12745L14.4386 13.745L14.4439 13.7469C14.614 13.8042 14.7951 13.8205 14.9727 13.7943C15.1502 13.7681 15.319 13.7002 15.4652 13.5961C15.6113 13.492 15.7306 13.3547 15.8135 13.1955C15.8964 13.0363 15.9402 12.8598 15.9415 12.6803V1.18334V1.17914C15.9402 0.999701 15.8964 0.823138 15.8135 0.663948C15.7306 0.504757 15.6113 0.367482 15.4652 0.263393C15.319 0.159305 15.1502 0.0913703 14.9727 0.0651706Z",
                        fill: "#339AF0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1748_34679",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icon_Megaphone = (Megaphone);

// EXTERNAL MODULE: ./src/components/atom/icon/WarningCircle.tsx
var WarningCircle = __webpack_require__(23155);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/home/useGetMyUncheckedAiAnswer.ts
var useGetMyUncheckedAiAnswer = __webpack_require__(13856);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/common/board-template/qna-home/ai-notification-banner/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 24px 0;\n  background-color: ",
        ";\n  & > div {\n    width: 100%;\n    padding: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: 16px;\n    ",
        "\n    color: ",
        ";\n\n    & > div {\n      display: flex;\n      align-items: center;\n      svg {\n        margin-right: 12px;\n      }\n    }\n\n    & > button {\n      padding: 10px 12px;\n      display: flex;\n      align-items: center;\n      border-radius: 8px;\n      ",
        ";\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var AiNotificationBanner = function(param) {
    var containerStyle = param.containerStyle;
    var aiAnswer = (0,useGetMyUncheckedAiAnswer/* default */.Z)();
    var moveToPage = (0,useCustomRouter/* default */.Z)().moveToPage;
    var bannerIcon = (0,react.useMemo)(function() {
        return (aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.status) === gql_schema/* QuestionStatus.PaymentFailed */.xVd.PaymentFailed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningCircle/* default */.Z, {
            width: 16,
            height: 16
        }) : (aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.aiAnswerStatus) === gql_schema/* AiAnswerStatus.GenerationComplete */.cx.GenerationComplete ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Megaphone, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningCircle/* default */.Z, {
            width: 16,
            height: 16
        });
    }, [
        aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.aiAnswerStatus
    ]);
    var bannerText = (0,react.useMemo)(function() {
        return (aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.status) === gql_schema/* QuestionStatus.PaymentFailed */.xVd.PaymentFailed ? "의료진 상담 결제가 실패됐어요." : (aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.aiAnswerStatus) === gql_schema/* AiAnswerStatus.GenerationComplete */.cx.GenerationComplete ? "확인하지 않은 답변이 있어요" : "불러오지 못한 답변이 있어요";
    }, [
        aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.aiAnswerStatus
    ]);
    var buttonText = (0,react.useMemo)(function() {
        return (aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.status) === gql_schema/* QuestionStatus.PaymentFailed */.xVd.PaymentFailed ? "확인하기" : (aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.aiAnswerStatus) === gql_schema/* AiAnswerStatus.GenerationComplete */.cx.GenerationComplete ? "보러가기" : "확인하기";
    }, [
        aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.aiAnswerStatus
    ]);
    var onClickQuestionDetail = function(questionPid) {
        if ((aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.status) === gql_schema/* QuestionStatus.PaymentFailed */.xVd.PaymentFailed) {
            moveToPage({
                webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
                mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
                params: {
                    questionId: aiAnswer.questionPid
                }
            });
            return;
        }
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.AI.path */.Z6.QNA.AI.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.AI.appScreenName */.Z6.QNA.AI.appScreenName,
            params: {
                questionPid: questionPid
            }
        });
    };
    if (aiAnswer && (aiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationRequested */.cx.GenerationRequested || aiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.Generating */.cx.Generating || aiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationComplete */.cx.GenerationComplete || aiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationFailed */.cx.GenerationFailed)) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AiBanner, {
            style: (0,_object_spread/* default */.Z)({}, containerStyle),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            bannerIcon,
                            bannerText
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            return onClickQuestionDetail((ref = aiAnswer === null || aiAnswer === void 0 ? void 0 : aiAnswer.questionPid) !== null && ref !== void 0 ? ref : "");
                        },
                        children: buttonText
                    })
                ]
            })
        });
    }
    return null;
};
/* harmony default export */ var ai_notification_banner = (AiNotificationBanner);
var AiBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eb687562-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray40;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI14SB, "\n        background-color: ").concat(theme.color.primary500, "\n        ");
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
});


/***/ }),

/***/ 11989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ MODAL_SHOW_PAGES; },
  "Z": function() { return /* binding */ cuj_useAppDownloadCujModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/recoil/atoms/cuj/index.ts
var cuj = __webpack_require__(15951);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/common/modal/cuj/AppDownloadCujModal.tsx






var AppDownloadCujModal = function() {
    var router = (0,next_router.useRouter)();
    var handleAppDownload = cuj_useAppDownloadCujModal().handleAppDownload;
    var onClickAppDownload = function() {
        (0,logger/* logger */.kg)({
            pageName: (0,logger/* getPageName */.j0)(router),
            eventName: "app_download_modal_click"
        });
        (0,cuj/* setAppDownloadCujModalState */.Ih)({
            isShow: false
        });
        handleAppDownload("지금 앱으로 진료받기");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-10 flex w-full flex-col items-center gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-1 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-19sb text-white",
                        children: "대한민국 1위 비대면 진료 앱 닥터나우"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "typography-ui-28b flex flex-col items-center text-primary-700",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "진료 가능해요"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[188px] overflow-hidden rounded-t-[20px] bg-gray-30 p-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full rounded-lg",
                            src: "/images/qna/appHomeScreen.png",
                            alt: "app_home_screen"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "typography-ui-17sb h-14 w-60 rounded-xl bg-primary-600 text-white",
                        type: "button",
                        onClick: onClickAppDownload,
                        children: "지금 앱으로 진료받기"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var cuj_AppDownloadCujModal = (AppDownloadCujModal);

// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
;// CONCATENATED MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx












var MODAL_SHOW_PAGES = [
    {
        path: "/",
        link: "https://abr.ge/fgbb8h"
    },
    {
        path: "/content/qna/realtime",
        link: "https://abr.ge/xl6mno"
    },
    {
        path: "/content/qna/[id]",
        link: "https://abr.ge/y2mlu1"
    },
    {
        path: "/hospitals",
        link: "https://abr.ge/1totxt"
    },
    {
        path: "/hospitals/search",
        link: "https://abr.ge/a1rxxv"
    },
    {
        path: "/hospitals/[hospitalPid]",
        link: "https://abr.ge/cmgskv"
    },
    {
        path: "/content/magazine",
        link: "https://abr.ge/dt8fv1"
    },
    {
        path: "/content/magazine/[id]",
        link: "https://abr.ge/054rrl"
    },
    {
        path: "/content/faq/[id]",
        link: "https://abr.ge/rgoppq"
    },
    {
        path: "/search",
        link: "https://abr.ge/yurdtxu"
    },
    {
        path: "/content/qna/ai-answer/[pid]",
        link: "https://abr.ge/mwmjor"
    }, 
];
var useAppDownloadCujModal = function() {
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), _isShow = ref1[0], _setIsShow = ref1[1];
    var appDownloadCujModal = (0,es.useRecoilValue)(cuj/* appDownloadCujModalState */.Ze);
    var modalShowPaths = MODAL_SHOW_PAGES.reduce(function(acc, cur) {
        return (0,_to_consumable_array/* default */.Z)(acc).concat([
            cur.path
        ]);
    }, []);
    var isShowPath = modalShowPaths.includes(router.pathname);
    (0,react.useEffect)(function() {
        if (_isShow && isShowPath && appDownloadCujModal && appDownloadCujModal.isShow) {
            showModal({
                type: modal/* MODAL_TYPE.CUSTOM_BACKGROUND */.f.CUSTOM_BACKGROUND,
                props: {
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)(cuj_AppDownloadCujModal, {}),
                    backgroundColor: theme/* default.color.dimmed80 */.Z.color.dimmed80,
                    onClickOverlay: function() {
                        closeModal();
                    }
                }
            });
        }
    }, [
        _isShow,
        isShowPath,
        appDownloadCujModal.isShow
    ]);
    (0,react.useEffect)(function() {
        var close = function() {
            closeModal();
        };
        window.addEventListener("popstate", close);
        return function() {
            window.removeEventListener("popstate", close);
        };
    });
    var setIsCujModalTrackingInfo = function(params) {
        (0,cuj/* setAppDownloadCujModalState */.Ih)({
            campaignName: params.campaignName,
            trackContent: params.trackContent,
            contentId: params.contentId,
            contentTitle: params.contentTitle,
            contentCategory: params.contentCategory,
            contentSubCategory: params.contentSubCategory
        });
    };
    var handleAppDownload = function(buttonText) {
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            campaign: appDownloadCujModal.campaignName || "unknown",
            content: appDownloadCujModal.trackContent,
            term: buttonText,
            sub_id: appDownloadCujModal.contentId,
            sub_id_1: appDownloadCujModal.contentTitle,
            sub_id_2: appDownloadCujModal.contentCategory
        }, appDownloadCujModal.contentSubCategory && {
            sub_id_3: appDownloadCujModal.contentSubCategory
        }));
    };
    return {
        setIsCujModalShow: _setIsShow,
        setIsCujModalTrackingInfo: setIsCujModalTrackingInfo,
        handleAppDownload: handleAppDownload
    };
};
/* harmony default export */ var cuj_useAppDownloadCujModal = (useAppDownloadCujModal);


/***/ }),

/***/ 40573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53476);



var useAppInstallTopBanner = function() {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_2__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .appInstallTopBannerState */ .Ep).isVisible;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    return {
        isVisible: isVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 13041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useIntersectionObserver = function(param) {
    var target = param.target, _freeze = param.freeze, freeze = _freeze === void 0 ? false : _freeze, _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, _root = param.root, root = _root === void 0 ? null : _root, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0%" : _rootMargin;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), entry = ref[0], setEntry = ref[1];
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var updateEntry = function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), currentEntry = _param[0];
        setEntry(currentEntry);
    };
    var cleanObserver = function() {
        if (observer.current) {
            observer.current.disconnect();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var hasIOSupport = "IntersectionObserver" in window;
        if (!freeze && target && hasIOSupport) {
            var observerParams = {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            };
            var observer = new IntersectionObserver(updateEntry, observerParams);
            observer.observe(target);
        }
        return function() {
            cleanObserver();
        };
    }, [
        target,
        root,
        rootMargin,
        threshold,
        freeze
    ]);
    return entry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersectionObserver);


/***/ }),

/***/ 86130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ realtime; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/icon/ArrowsButtonDownMin.tsx
var ArrowsButtonDownMin = __webpack_require__(92803);
// EXTERNAL MODULE: ./src/components/common/communication/qna/CategoryBottomSheet.tsx
var CategoryBottomSheet = __webpack_require__(80138);
// EXTERNAL MODULE: ./src/components/common/qna-sticky-write-button/index.tsx + 1 modules
var qna_sticky_write_button = __webpack_require__(47396);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/hooks/useScreenFocus.tsx
var useScreenFocus = __webpack_require__(50341);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(42411);
// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 3 modules
var PaginationComponent = __webpack_require__(29697);
// EXTERNAL MODULE: ./src/components/molecules/question-list/QuestionsSkeleton.tsx
var QuestionsSkeleton = __webpack_require__(3807);
// EXTERNAL MODULE: ./src/components/molecules/question-list/question-item/index.tsx + 1 modules
var question_item = __webpack_require__(60987);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/qna/hook/qna.gql.impl.tsx


var SearchQuestionsItemsDocument = "\n    query SearchQuestionsItems($request: QuestionSearchRequestInput!) {\n  searchQuestions(request: $request) {\n    items {\n      status\n      accessibleType\n      attachments {\n        blindType\n        id\n      }\n      category {\n        name\n        id\n        iconImagePath\n      }\n      tags {\n        name\n      }\n      createdAt\n      content\n      isBlockedByMe\n      publicId\n      title\n      userMaskedName\n      userId\n    }\n  }\n}\n    ";
var useSearchQuestionsItemsQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "SearchQuestionsItems",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsItemsDocument, "SearchQuestionsItems", variables), options);
};
useSearchQuestionsItemsQuery.getKey = function(variables) {
    return [
        "SearchQuestionsItems",
        variables
    ];
};
useSearchQuestionsItemsQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsItemsDocument, "SearchQuestionsItems", variables, options);
};
var SearchQuestionsTotalCountDocument = "\n    query SearchQuestionsTotalCount($request: QuestionSearchRequestInput!) {\n  searchQuestions(request: $request) {\n    totalCount\n  }\n}\n    ";
var useSearchQuestionsTotalCountQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "SearchQuestionsTotalCount",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsTotalCountDocument, "SearchQuestionsTotalCount", variables), options);
};
useSearchQuestionsTotalCountQuery.getKey = function(variables) {
    return [
        "SearchQuestionsTotalCount",
        variables
    ];
};
useSearchQuestionsTotalCountQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(SearchQuestionsTotalCountDocument, "SearchQuestionsTotalCount", variables, options);
};

;// CONCATENATED MODULE: ./src/entities/qna/hook/useSearchQuestions.ts







var DEFAULT_SIZE = 20;
var parseRealtimeQnaCardVo = function(data) {
    var items = data.searchQuestions.items.map(function(item) {
        var _title;
        return {
            answeredStatus: gql_schema/* QuestionAnsweredStatus.Answered */.G26.Answered,
            answer: null,
            answererCount: 0,
            answererProfileImageUrls: [],
            question: {
                accessibleType: item.accessibleType,
                content: item.content,
                createdAt: item.createdAt,
                isBlockedByMe: item.isBlockedByMe,
                isLikedByMe: false,
                isMine: false,
                likeCount: 0,
                questionPid: item.publicId,
                title: (_title = item.title) !== null && _title !== void 0 ? _title : "",
                attachments: (0,format/* sortImageBlindTypeFormat */.zV)(item.attachments.map(function(attachment) {
                    return {
                        blindType: attachment.blindType,
                        questionAttachmentId: attachment.id
                    };
                })),
                category: {
                    name: item.category.name,
                    questionCategoryId: item.category.id,
                    iconImageUrl: item.category.iconImagePath
                },
                tags: item.tags,
                user: {
                    name: item.userMaskedName,
                    userId: item.userId
                }
            },
            questionCreatedAt: (0,format/* absoluteDate */.xt)(item.createdAt),
            answerCreatedAt: null,
            answeredStatusText: ""
        };
    });
    return items;
};
var parseRealtimeQnaCardTotalCount = function(data) {
    return data.searchQuestions.totalCount;
};
var useSearchQuestions = function(param) {
    var categoryIds = param.categoryIds, _page = param.page, page = _page === void 0 ? 1 : _page, _size = param.size, size = _size === void 0 ? DEFAULT_SIZE : _size;
    var request = {
        categoryIds: categoryIds,
        page: page,
        size: size,
        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
    };
    var ref = useSearchQuestionsTotalCountQuery({
        request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
            page: 1
        })
    }, {
        staleTime: 5000,
        cacheTime: 5000,
        select: parseRealtimeQnaCardTotalCount
    }), tmp = ref.data, totalCount = tmp === void 0 ? 0 : tmp, isLoadingTotalCount = ref.isLoading;
    var ref1 = useSearchQuestionsItemsQuery({
        request: request
    }, {
        select: parseRealtimeQnaCardVo
    }), tmp1 = ref1.data, questions = tmp1 === void 0 ? [] : tmp1, isLoading = ref1.isLoading;
    var totalPage = Math.ceil(totalCount / size);
    return {
        totalCount: totalCount,
        totalPage: totalPage,
        isLoading: isLoadingTotalCount || isLoading,
        questions: questions
    };
};
/* harmony default export */ var hook_useSearchQuestions = (useSearchQuestions);
useSearchQuestions.prefetchTotalCountQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, variables) {
        var _size, request;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = {
                        categoryIds: variables.categoryIds,
                        page: 1,
                        size: (_size = variables.size) !== null && _size !== void 0 ? _size : DEFAULT_SIZE,
                        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
                    };
                    return [
                        4,
                        queryClient.prefetchQuery({
                            queryKey: useSearchQuestionsTotalCountQuery.getKey({
                                request: request
                            }),
                            queryFn: function() {
                                return useSearchQuestionsTotalCountQuery.fetcher({
                                    request: request
                                })();
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variables) {
        return _ref.apply(this, arguments);
    };
}();
useSearchQuestions.prefetchItemsQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, variables) {
        var _page, _size, request;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = {
                        categoryIds: variables.categoryIds,
                        page: (_page = variables.page) !== null && _page !== void 0 ? _page : 1,
                        size: (_size = variables.size) !== null && _size !== void 0 ? _size : DEFAULT_SIZE,
                        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
                    };
                    return [
                        4,
                        queryClient.prefetchQuery({
                            queryKey: useSearchQuestionsItemsQuery.getKey({
                                request: request
                            }),
                            queryFn: function() {
                                return useSearchQuestionsItemsQuery.fetcher({
                                    request: request
                                })();
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variables) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
;// CONCATENATED MODULE: ./src/features/qna/realtime-web/view-models/useRealtimeWebQnaViewModel.ts



var useRealtimeWebQnaViewModel_DEFAULT_SIZE = 20;
var useRealtimeWebQnaViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var _query = router.query, _categoryId = _query.categoryId, categoryId = _categoryId === void 0 ? "" : _categoryId, _page = _query.page, page = _page === void 0 ? "1" : _page;
    var selectedCategoryIds = (0,react.useMemo)(function() {
        return categoryId ? [
            categoryId
        ] : [];
    }, [
        categoryId
    ]);
    var ref = hook_useSearchQuestions({
        categoryIds: selectedCategoryIds,
        page: Number(page),
        size: useRealtimeWebQnaViewModel_DEFAULT_SIZE
    }), questions = ref.questions, isQnaListLoading = ref.isLoading, totalPage = ref.totalPage;
    return {
        queries: {
            categoryId: categoryId,
            page: page
        },
        questions: questions,
        isQnaListLoading: isQnaListLoading,
        totalPage: totalPage
    };
};
/* harmony default export */ var view_models_useRealtimeWebQnaViewModel = (useRealtimeWebQnaViewModel);

// EXTERNAL MODULE: ./src/models/ad/list.ts
var list = __webpack_require__(70847);
// EXTERNAL MODULE: ./src/shared/ui/index.ts + 23 modules
var ui = __webpack_require__(2149);
// EXTERNAL MODULE: ./src/shared/ui/QnaNativeDefault.tsx + 1 modules
var QnaNativeDefault = __webpack_require__(34418);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/features/qna/realtime-web/ui/RealtimeWebQna.tsx











var RealtimeWebQna = function(param) {
    var client = param.client;
    var viewModel = view_models_useRealtimeWebQnaViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            viewModel.isQnaListLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionsSkeleton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: viewModel.questions.map(function(qna, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdQnaNative */.Vh, {
                                    adPageType: list/* AdPageType.QnaListNative */.hO.QnaListNative,
                                    client: client,
                                    fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaNativeDefault/* default */.Z, {
                                        title: "몸살감기 집에서 비대면 진료 가능할까요?",
                                        content: "기침이 심하고 열도 나서 외출이 어려운데, 비대면 진료로 약을 처방 받을 수 있을까요?",
                                        tagList: [
                                            {
                                                name: "감기"
                                            },
                                            {
                                                name: "코로나"
                                            }
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(qna.question.questionPid),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(question_item/* default */.Z, {
                                            questionCard: qna,
                                            onClickQuestion: function() {}
                                        })
                                    })
                                })
                            ]
                        })
                    }, "qna-".concat(qna.question.questionPid));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                totalPage: viewModel.totalPage,
                queries: viewModel.queries,
                baseUrl: common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path,
                currentPage: Number(viewModel.queries.page),
                scroll: false,
                scrollRestoration: true
            })
        ]
    });
};
/* harmony default export */ var ui_RealtimeWebQna = (RealtimeWebQna);

// EXTERNAL MODULE: ./src/components/molecules/question-list/index.tsx + 1 modules
var question_list = __webpack_require__(31867);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ../../node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(84636);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
;// CONCATENATED MODULE: ./src/entities/qna/hook/useSearchQuestionsInfinite.ts








var useSearchQuestionsInfinite_DEFAULT_SIZE = 20;
var useSearchQuestionsInfinite_parseRealtimeQnaCardVo = function(data) {
    var items = data.searchQuestions.items.map(function(item) {
        var _title;
        return {
            answeredStatus: gql_schema/* QuestionAnsweredStatus.Answered */.G26.Answered,
            answer: null,
            answererCount: 0,
            answererProfileImageUrls: [],
            question: {
                accessibleType: item.accessibleType,
                content: item.content,
                createdAt: item.createdAt,
                isBlockedByMe: item.isBlockedByMe,
                isLikedByMe: false,
                isMine: false,
                likeCount: 0,
                questionPid: item.publicId,
                title: (_title = item.title) !== null && _title !== void 0 ? _title : "",
                attachments: item.attachments.map(function(attachment) {
                    return {
                        blindType: attachment.blindType,
                        questionAttachmentId: attachment.id
                    };
                }),
                category: {
                    name: item.category.name,
                    questionCategoryId: item.category.id,
                    iconImageUrl: item.category.iconImagePath
                },
                tags: item.tags,
                user: {
                    name: item.userMaskedName,
                    userId: item.userId
                }
            },
            questionCreatedAt: (0,format/* absoluteDate */.xt)(item.createdAt),
            answerCreatedAt: null,
            answeredStatusText: ""
        };
    });
    return items;
};
var useSearchQuestionsInfinite_parseRealtimeQnaCardTotalCount = function(data) {
    return data.searchQuestions.totalCount;
};
var useSearchQuestionsInfinite = function(param) {
    var categoryIds = param.categoryIds, _page = param.page, page = _page === void 0 ? 1 : _page, _size = param.size, size = _size === void 0 ? useSearchQuestionsInfinite_DEFAULT_SIZE : _size;
    var ref = useSearchQuestionsTotalCountQuery({
        request: {
            categoryIds: categoryIds,
            page: 1,
            size: size,
            sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
        }
    }, {
        staleTime: 5000,
        cacheTime: 5000,
        select: useSearchQuestionsInfinite_parseRealtimeQnaCardTotalCount
    }), tmp = ref.data, totalCount = tmp === void 0 ? 0 : tmp, isLoadingTotalCount = ref.isLoading;
    var totalPage = Math.ceil(totalCount / size);
    var ref1 = (0,useInfiniteQuery/* useInfiniteQuery */.N)(useSearchQuestionsItemsQuery.getKey({
        request: {
            categoryIds: categoryIds,
            page: 1,
            size: size,
            sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
        }
    }), function(param) {
        var pageParam = param.pageParam;
        var requestPage = pageParam !== null && pageParam !== void 0 ? pageParam : page;
        return useSearchQuestionsItemsQuery.fetcher({
            request: {
                categoryIds: categoryIds,
                page: requestPage,
                size: size,
                sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
            }
        })();
    }, {
        enabled: !!totalPage,
        getNextPageParam: function(_, pages) {
            if (pages.length < totalPage) {
                return pages.length + 1;
            }
            return undefined;
        }
    }), data = ref1.data, isLoading = ref1.isLoading, fetchNextPage = ref1.fetchNextPage, _hasNextPage = ref1.hasNextPage, hasNextPage = _hasNextPage === void 0 ? false : _hasNextPage;
    var qnaList = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        var qnas = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(page) {
            return useSearchQuestionsInfinite_parseRealtimeQnaCardVo(page);
        })) !== null && ref1 !== void 0 ? ref1 : [];
        return uniqBy_default()(qnas, "question.questionPid");
    }, [
        data
    ]);
    return {
        totalPage: totalPage,
        questions: qnaList,
        isLoading: isLoadingTotalCount || isLoading,
        fetchNextPage: fetchNextPage,
        hasNextPage: hasNextPage
    };
};
/* harmony default export */ var hook_useSearchQuestionsInfinite = (useSearchQuestionsInfinite);
useSearchQuestionsInfinite.prefetchInfiniteQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, variables) {
        var _size, request;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = {
                        categoryIds: variables.categoryIds,
                        page: 1,
                        size: (_size = variables.size) !== null && _size !== void 0 ? _size : useSearchQuestionsInfinite_DEFAULT_SIZE,
                        sort: gql_schema/* QuestionSearchSort.Recent */.nyr.Recent
                    };
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(useSearchQuestionsItemsQuery.getKey({
                            request: request
                        }), function() {
                            return useSearchQuestionsItemsQuery.fetcher({
                                request: request
                            })();
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, variables) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/qna/realtime-webview/view-models/useRealtimeWebViewQnaViewModel.ts



var useRealtimeWebViewQnaViewModel_DEFAULT_SIZE = 20;
var useRealtimeWebViewQnaViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var _query = router.query, _categoryId = _query.categoryId, categoryId = _categoryId === void 0 ? "" : _categoryId, _page = _query.page, page = _page === void 0 ? "1" : _page;
    var selectedCategoryIds = (0,react.useMemo)(function() {
        return categoryId ? [
            categoryId
        ] : [];
    }, [
        categoryId
    ]);
    var ref = hook_useSearchQuestionsInfinite({
        categoryIds: selectedCategoryIds,
        page: Number(page),
        size: useRealtimeWebViewQnaViewModel_DEFAULT_SIZE
    }), questions = ref.questions, isLoading = ref.isLoading, hasNextPage = ref.hasNextPage, fetchNextPage = ref.fetchNextPage, totalPage = ref.totalPage;
    return {
        queries: {
            categoryId: categoryId,
            page: page
        },
        questions: questions,
        isQnaListLoading: isLoading,
        totalPage: totalPage,
        hasNextPage: hasNextPage,
        fetchNextPage: fetchNextPage
    };
};
/* harmony default export */ var view_models_useRealtimeWebViewQnaViewModel = (useRealtimeWebViewQnaViewModel);

;// CONCATENATED MODULE: ./src/features/qna/realtime-webview/ui/RealtimeWebviewQna.tsx




var RealtimeWebviewQna = function(props) {
    var viewModel = view_models_useRealtimeWebViewQnaViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(question_list/* default */.Z, {
        questionCard: {
            data: viewModel.questions,
            isLoading: viewModel.isQnaListLoading,
            hasNextPage: viewModel.hasNextPage,
            fetchNextPage: viewModel.fetchNextPage
        },
        onClickQuestion: props.onClickQuestion,
        advertisementComponent: props.advertisementComponent,
        pageName: props.pageName
    });
};
/* harmony default export */ var ui_RealtimeWebviewQna = (RealtimeWebviewQna);

// EXTERNAL MODULE: ./src/hooks/cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(40573);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/common/board-template/qna-home/ai-notification-banner/index.tsx + 1 modules
var ai_notification_banner = __webpack_require__(33193);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-realtime-template/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 26px 24px 0 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 8px;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          gap: 12px;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "\n  padding: 16px 24px 0px;\n\n  & > * {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 12px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





















var QnaRealtimeTemplate = function(param) {
    var client = param.client, viewModel = param.viewModel;
    var ref, ref1, ref2, ref3;
    (0,useScreenFocus/* default */.Z)();
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    visible: true,
                    name: (ref4 = (ref = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref === void 0 ? void 0 : ref.title) !== null && ref4 !== void 0 ? ref4 : "전체",
                    path: "".concat(common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path),
                    type: "qna",
                    urlParameter: ((ref1 = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref1 === void 0 ? void 0 : ref1.value) ? "?categoryId=".concat((ref2 = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref2 === void 0 ? void 0 : ref2.value) : ""
                })
            }),
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: "실시간 의료상담"
                })
            }),
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AdBandCta */.IY, {
                    client: client,
                    onClose: topBannerViewModel.hideBanner,
                    enableAnimation: true,
                    fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                        content: "web_content_bnr_service",
                        onClickClose: topBannerViewModel.hideBanner,
                        trackingInfo: {
                            campaign: "web_content_qna"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    client.clientType !== app/* ClientType.MOBILE_WEBVIEW */.B.MOBILE_WEBVIEW && "닥터나우 실시간 의료 상담 - ",
                                    (ref5 = (ref3 = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref3 === void 0 ? void 0 : ref3.title) !== null && ref5 !== void 0 ? ref5 : "전체"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryButton, {
                                onClick: viewModel.onClickCategoriesBottomSheetTrigger,
                                children: [
                                    "증상/과목 선택",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsButtonDownMin/* default */.Z, {
                                        size: 12
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdBanner */.g7, {
                        className: "px-[24px] pt-[24px]",
                        adPageType: list/* AdPageType.QnaListBanner */.hO.QnaListBanner,
                        client: client,
                        borderRadius: 8,
                        fallbackContent: null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_notification_banner/* default */.Z, {}),
                    client.isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_RealtimeWebviewQna, {
                        onClickQuestion: viewModel.onClickQuestion,
                        pageName: viewModel.pageName,
                        advertisementComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UnifiedAdQnaNative */.Vh, {
                            adPageType: list/* AdPageType.QnaListNative */.hO.QnaListNative,
                            client: client,
                            fallbackContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* QnaNativeDefault */.jc, {
                                title: "몸살감기 집에서 비대면 진료 가능할까요?",
                                content: "기침이 심하고 열도 나서 외출이 어려운데, 비대면 진료로 약을 처방 받을 수 있을까요?",
                                tagList: [
                                    {
                                        name: "감기"
                                    },
                                    {
                                        name: "코로나"
                                    }
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_RealtimeWebQna, {
                        client: client
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_sticky_write_button/* default */.Z, {
                        buttonText: viewModel.bottomButtonText,
                        pageName: viewModel.pageName,
                        onClickButton: viewModel.onClickStickButton
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBottomSheet/* default */.Z, {
                        isVisible: viewModel.showCategoriesBottomSheet,
                        toggleBottomSheet: viewModel.toggleCategoriesBottomSheet,
                        onClickCategoryItem: viewModel.onClickCategoriesBottomSheetTabListItem,
                        categoryGroup: viewModel.categoryGroup,
                        selectedTab: viewModel.selectedTab,
                        onClickCategoriesBottomSheetTab: viewModel.onClickCategoriesBottomSheetTab,
                        getSelectedTabItemList: viewModel.getSelectedTabItemList
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var qna_realtime_template = (QnaRealtimeTemplate);
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-282ef329-0"
})(_templateObject());
var CategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-282ef329-1"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.client.isMobile ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI22SB, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var CategoryButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-282ef329-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray600, ";\n    background: ").concat(theme.color.gray50, ";\n    \n    &: hover {\n      background: ").concat(theme.color.gray100, ";\n    }\n    &: active {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});

// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(99529);
// EXTERNAL MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(11989);
// EXTERNAL MODULE: ./src/hooks/qna/useGetQnaCategoryGroup.ts
var useGetQnaCategoryGroup = __webpack_require__(62139);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/types/qna.ts
var qna = __webpack_require__(18457);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/hooks/qna/list/useQnaRealtimeViewModel.ts













var BOTTOME_BUTTON_TEXT = "실시간 의료상담 물어보기";
var useQnaRealtimeViewModel = function() {
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, moveToPage = ref.moveToPage;
    var _query = router.query, _page = _query.page, page = _page === void 0 ? "1" : _page, _categoryId = _query.categoryId, categoryId = _categoryId === void 0 ? "" : _categoryId;
    var navigate = (0,useNavigate/* default */.Z)();
    var pageName = (0,logger/* getPageName */.j0)(router);
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var ref1 = (0,react.useState)(false), showCategoriesBottomSheet = ref1[0], setShowCategoriesBottomSheet = ref1[1];
    var ref2 = (0,react.useState)(qna/* QnaCategoryType.TREATMENT */.Q0.TREATMENT), selectedTab = ref2[0], setSelectedTab = ref2[1];
    var ref3 = (0,react.useState)(), selectedCategoriesBottomSheetTabItem = ref3[0], setSelectedCategoriesBottomSheetTabItem = ref3[1];
    var categoryGroup = (0,useGetQnaCategoryGroup/* default */.Z)().categoryGroup;
    // 카테고리 Bottom Sheet on/off
    var toggleCategoriesBottomSheet = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        setShowCategoriesBottomSheet(value);
    };
    // 카테고리 Bottom Sheet on
    var onClickCategoriesBottomSheetTrigger = function() {
        (0,logger/* communityLogger */.S4)({
            eventName: "filter_categories_click",
            pageName: pageName
        });
        toggleCategoriesBottomSheet();
    };
    // 카테고리 Bottom Sheet Tab Click
    var onClickCategoriesBottomSheetTab = function(tab) {
        setSelectedTab(tab.value);
    };
    // 카테고리 Bottom Sheet Tab Item Click
    var onClickCategoriesBottomSheetTabListItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,logger/* communityLogger */.S4)({
                    eventName: "category_item_click",
                    pageName: pageName,
                    payload: {
                        categoryId: item.value
                    }
                });
                toggleCategoriesBottomSheet(false);
                setSelectedCategoriesBottomSheetTabItem(item);
                router.replace({
                    pathname: common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path,
                    query: {
                        categoryId: item.value,
                        page: "1"
                    }
                }, undefined, {
                    shallow: true
                });
                return [
                    2
                ];
            });
        });
        return function onClickCategoriesBottomSheetTabListItem(item) {
            return _ref.apply(this, arguments);
        };
    }();
    // 질문 클릭 -> 상세페이지 이동
    var onClickQuestion = function(param) {
        var questionId = param.questionId, sectionName = param.sectionName;
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionId),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionId
            }
        });
        (0,logger/* communityLogger */.S4)({
            eventName: "quick_answer_item_click",
            pageName: pageName,
            payload: {
                section_name: sectionName !== null && sectionName !== void 0 ? sectionName : "",
                questionId: questionId
            }
        });
    };
    // 하단 버튼 클릭
    var onClickStickButton = function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            navigate.navigateToQnaWrite();
            return;
        }
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, {
            campaign: "web_content_qna",
            content: "web_content_flt_list",
            term: BOTTOME_BUTTON_TEXT
        });
    };
    var getSelectedTabItemList = function() {
        if (!categoryGroup) return [];
        return categoryGroup.tabsList.filter(function(tab) {
            return tab.key === selectedTab;
        })[0].categories;
    };
    // 글로벌 앱 설치 모달 트래킹 정보 저장
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    (0,react.useEffect)(function() {
        setIsCujModalTrackingInfo({
            campaignName: "web_content_qna",
            trackContent: "web_content_mdl_list"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (categoryGroup && categoryId) {
            var selectedCategory = categoryGroup.categories.filter(function(category) {
                return category.value === categoryId;
            })[0];
            setSelectedCategoriesBottomSheetTabItem(selectedCategory);
        }
    }, [
        categoryGroup,
        categoryId
    ]);
    (0,react.useEffect)(function() {
        if (!router.query.categoryId) {
            setSelectedCategoriesBottomSheetTabItem({});
        }
    }, [
        categoryId
    ]);
    return {
        queries: {
            categoryId: categoryId,
            page: page
        },
        onClickQuestion: onClickQuestion,
        pageName: pageName,
        showCategoriesBottomSheet: showCategoriesBottomSheet,
        selectedCategoriesBottomSheetTabItem: selectedCategoriesBottomSheetTabItem,
        toggleCategoriesBottomSheet: toggleCategoriesBottomSheet,
        onClickCategoriesBottomSheetTrigger: onClickCategoriesBottomSheetTrigger,
        onClickCategoriesBottomSheetTabListItem: onClickCategoriesBottomSheetTabListItem,
        categoryGroup: categoryGroup,
        selectedTab: selectedTab,
        onClickCategoriesBottomSheetTab: onClickCategoriesBottomSheetTab,
        getSelectedTabItemList: getSelectedTabItemList,
        onClickStickButton: onClickStickButton,
        bottomButtonText: BOTTOME_BUTTON_TEXT
    };
};
/* harmony default export */ var list_useQnaRealtimeViewModel = (useQnaRealtimeViewModel);

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/pages/content/qna/realtime/index.tsx
// PageDescription: 실시간 의료 상담 리스트 페이지








var QnaRealtime = function(param) {
    var client = param.client;
    var viewModel = list_useQnaRealtimeViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "실시간 의료상담 - 닥터나우",
                description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path).concat((0,url/* addQueryString */.sC)(viewModel.queries)),
                openGraph: {
                    title: "실시간 의료상담 - 닥터나우",
                    description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.REALTIME.path */.Z6.QNA.REALTIME.path).concat((0,url/* addQueryString */.sC)(viewModel.queries)),
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/og-qna.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_realtime_template, {
                client: client,
                viewModel: viewModel
            })
        ]
    });
};
QnaRealtime.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var realtime = (QnaRealtime);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,6492,9097,1498,2110,7654,1680,8391,9653,5180,6326,1743,4365,5679,2149,1950,5250,1855,1867,6412,9774,2888,179], function() { return __webpack_exec__(14524); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);